import { Injectable } from '@angular/core';

import { GeoAreaModification } from '@features/components/visualization/mapbox/models/galia-area';

/**
 * The boundaries currently on the map that can be reshaped in place, keyed by the uid the
 * map draws them under. Filled from the visualization effect whenever the visualized
 * entities change, so what the map offers to edit is always what it is showing.
 */
@Injectable({ providedIn: 'root' })
export class GeoAreaModificationActionsService {
  private modifications = new Map<string, GeoAreaModification>();

  setModifications(map: Map<string, GeoAreaModification>): void {
    this.modifications = map;
  }

  getModification(uid: string): GeoAreaModification | undefined {
    return this.modifications.get(uid);
  }
}
